// src/pages/Home/components/sections/AboutSection.jsx
import React from "react";

export default function AboutSection({ t }) {
  return (
    <section className="aq-section" id="about">
      <div className="aq-container">
        <div className="aq-section-head">
          <h2>{t("about.title")}</h2>
          <p className="aq-muted">{t("about.desc")}</p>
        </div>

        <div className="aq-grid-3">
          <div className="aq-card">
            <h3>{t("about.c1t")}</h3>
            <p className="aq-muted">{t("about.c1d")}</p>
          </div>
          <div className="aq-card">
            <h3>{t("about.c2t")}</h3>
            <p className="aq-muted">{t("about.c2d")}</p>
          </div>
          <div className="aq-card">
            <h3>{t("about.c3t")}</h3>
            <ul className="aq-list">
              <li>{t("about.v1")}</li>
              <li>{t("about.v2")}</li>
              <li>{t("about.v3")}</li>
              <li>{t("about.v4")}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
